import init from 'rev.sdk.js/Config/featureOptions';

init({
  points: false,
  coupon: false,
  facebookPixel: {},
  googleAnalytics: {},
});
